var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlobShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 555,
    viewBox: "0 0 479 555",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.756 191.789C101.605 134.839 151.708 93.3549 209.122 96.2684L227.374 97.1946C257.45 98.7209 286.501 86.0498 305.844 62.9681C324.09 41.1953 351.04 28.6181 379.447 28.6181H397.476C408.092 28.6181 418.554 26.0816 427.992 21.2199L465.154 2.07589C473.45 -2.198 483.628 0.306503 488.993 7.9423C491.352 11.2992 492.54 15.3393 492.374 19.4388L479.63 334.118V539.118C479.63 547.402 472.915 554.118 464.63 554.118H86.3952C65.5421 554.118 45.0121 548.965 26.6304 539.118C0.564571 527.874 -8.22882 495.281 8.64455 472.452L20.1664 456.864C24.3613 451.188 30.2907 447.034 37.0574 445.029C53.833 440.058 63.6558 422.692 59.2724 405.753L36.9445 319.474C30.8806 296.041 41.5185 271.486 62.7603 259.883C77.4593 251.854 87.4794 237.33 89.7661 220.738L93.756 191.789Z",
    fill: "url(#paint0_linear_2406_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2406_7",
    x1: 41.1304,
    y1: 281.713,
    x2: 679.51,
    y2: 577.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471154,
    stopColor: "#FF7400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobShape);
export default __webpack_public_path__ + "static/media/blob-shape.20dfe6c7fa56bec40f368a6c75d3e3b3.svg";
export { ForwardRef as ReactComponent };